import { render, staticRenderFns } from "./teletareas_asignatura.vue?vue&type=template&id=8e81fb1a"
import script from "./teletareas_asignatura.vue?vue&type=script&lang=js"
export * from "./teletareas_asignatura.vue?vue&type=script&lang=js"
import style0 from "./teletareas_asignatura.vue?vue&type=style&index=0&id=8e81fb1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports